module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/desktop-c115e83a5e826f850b26401b6568db31.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/desktop.svg
// module id = jXML
// module chunks = 24